var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("sidebar-widget", {
    staticClass: "sidebar-search",
    attrs: {
      id: "search-widget",
      title: _vm.$gettext("Suche"),
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "sidebar-search",
              },
              [
                _c(
                  "ul",
                  {
                    staticClass: "needles",
                  },
                  [
                    _c("li", [
                      _c(
                        "div",
                        {
                          staticClass: "input-group files-search",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.searchterm,
                                expression: "searchterm",
                                modifiers: {
                                  trim: true,
                                },
                              },
                            ],
                            attrs: {
                              type: "text",
                              id: "searchterm",
                              name: "searchterm",
                              placeholder: _vm.$gettext("Veranstaltung suchen"),
                              "aria-label": _vm.$gettext(
                                "Veranstaltung suchen"
                              ),
                            },
                            domProps: {
                              value: _vm.searchterm,
                            },
                            on: {
                              input: function input($event) {
                                if ($event.target.composing) return
                                _vm.searchterm = $event.target.value.trim()
                              },
                              blur: function blur($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.isActive
                            ? _c(
                                "a",
                                {
                                  staticClass: "reset-search",
                                  on: {
                                    click: function click($event) {
                                      $event.preventDefault()
                                      return _vm.cancelSearch.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("studip-icon", {
                                    attrs: {
                                      shape: "decline",
                                      size: 20,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "submit-search",
                              attrs: {
                                type: "submit",
                                title: _vm.$gettext("Suchen"),
                              },
                              on: {
                                click: function click($event) {
                                  $event.preventDefault()
                                  return _vm.doSearch.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c("studip-icon", {
                                attrs: {
                                  shape: "search",
                                  role: _vm.maySearch
                                    ? "clickable"
                                    : "inactive",
                                  size: 20,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }